
import {
    Box, TextField, FormControl, InputAdornment, InputLabel, Input, IconButton, Button,
    Typography, Select, MenuItem, FormHelperText, Alert, Checkbox, Paper, Divider, Accordion,

    AccordionSummary,
    AccordionDetails,
} from '@mui/material';
import { AccountCircleOutlined, Visibility, VisibilityOff, LockOutlined, Group, ExpandMore as ExpandMoreIcon, } from '@mui/icons-material';
import { useState, useEffect } from 'react';
import { useSelector, useDispatch, } from 'react-redux';
import { range, set, uniqBy } from 'lodash';
import { Tabs } from '../../components/tabs';
import { Grid } from '../../components/table';
import { CONFIG } from '../../../config'
import axios from 'axios';
import { Modal } from "../../components/modal";
import { ToolBar } from '../../components/toolbar';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { FormA } from '../../components/form';
import { getFormState } from '../../../helpers/form';
const API_HOST = CONFIG.modules['accounts'].host

const fields = [
    {
        type: "text",
        label: "Name",
        required: true,
        name: "name",
    },
    {
        type: "select",
        label: "Group Members",
        option: { key: "GroupMembers", value: "_id", label: "name" },
        multiple: true,
        name: "members",
    },
]

export const GroupTemplates = ({ team }) => {
    const { roles, user, users, Designations, Departments, Languages, Districts, TaskTypes, Campaigns } = useSelector((state) => (state.user || {}))

    const dispatch = useDispatch()


    const [open, setOpen] = useState(false);
    const [formData, setFormData] = useState(getFormState(fields))
    const [groups, setGroups] = useState([]);
    const [action, setAction] = useState('new');
    const [selected, setSelected] = useState(null);
    const [usedMembers, setUsedMembers] = useState({})

    useEffect(() => {
        getGroups()
    }, [])

    useEffect(()=> {
        // console.log(team.members)
    },[team])

    useEffect(()=> {
        // console.log(formData)
    },[formData])

    useEffect(()=> {
        // console.log(usedMembers)
    },[usedMembers])

    useEffect(() => {
        if(groups.length>0) {
            setUsedMembers(groups.reduce((a,e) =>{
                if(e.members.length>0) {
                    e.members.forEach(member => {
                        a[member._id]=member
                    });
                }
                return a
            },{}))
        }
    },[groups])

    const getGroups = () => {
        const { department } = team;
        axios.get(API_HOST + `/groups?department=${department._id}&lead=${user._id}`)
            .then((resp) => {
                if (resp.data && resp.data.success) {
                    setGroups(resp.data.groups)
                }
            })
            .catch((e) => {
                console.log(e);
            });
    }


    const handleSubmit = () => {
        const { department } = team;
        axios.post(API_HOST + '/groups', {
            group: {
                ...formData,
                department: department._id,
                lead: user._id
            }
        })
            .then((resp) => {
                if (resp.data && resp.data.success) {
                    setGroups([resp.data.group, ...groups])
                }
                setOpen(false);
            })
            .catch((e) => {
                console.log(e);
                setOpen(false);
            });
    };

    const handleEdit = () => {
        const { department } = team;
        axios.put(API_HOST + '/groups/'+selected._id, {
            group: {
                ...formData,
                department: department._id,
                lead: user._id
            }
        })
            .then((resp) => {
                if (resp.data && resp.data.success) {
                    
                    let newGs = [...groups];
                    const index = newGs.findIndex(g=>g._id == selected._id);
                    if(index>-1) {
                        newGs[index] = {...resp.data.group};
                    }
                    console.log(index, newGs, resp.data.group)
                    setGroups([...newGs])
                }
                setOpen(false);
            })
            .catch((e) => {
                console.log(e);
                setOpen(false);
            });
    }




    return (
        <>

            <Box>

                <ToolBar
                    buttons={[
                        {
                            name: "Add new",
                            onClick: () => {
                                setFormData(getFormState(fields))
                                setAction('new')
                                setOpen(true);
                            },
                        },
                    ]}
                />
                <Box>
                    {
                        groups.map((g, i) => {
                            return (
                                <Accordion key={i}>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel1a-content"
                                        id="panel1a-header"
                                    >
                                        <Typography sx={{ fontWeight: 'bold', fontSize: '.8em' }}>{g.name} &nbsp; {`Total -  ${g.members.length || 0}`}</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Paper >
                                            <div className="container">
                                                <div>
                                                    <div className="px-3">
                                                        <div className="list my-3">
                                                            <div className="row justify-content-end">
                                                                <div className="m-2">
                                                                    <Button
                                                                        variant="contained"
                                                                        size="small"
                                                                        onClick={() => {
                                                                            setSelected(g)
                                                                            setFormData({...g, members: g.members.map(m=>m._id) })
                                                                            setAction('edit')
                                                                            setOpen(true);
                                                                        }}
                                                                    >
                                                                        {'Edit'}
                                                                    </Button>
                                                                </div>
                                                            </div>
                                                            <div className="row justify-content-center">
                                                                {g.members.length > 0 &&
                                                                    g.members.map((member) => (
                                                                        <div className="col-md-2 mb-3 p-2" key={member._id}>
                                                                            <Paper>
                                                                                <div className="text-center  py-3">
                                                                                    <div className="img">
                                                                                        <img
                                                                                            src="https://t4.ftcdn.net/jpg/03/32/59/65/240_F_332596535_lAdLhf6KzbW6PWXBWeIFTovTii1drkbT.jpg"
                                                                                            alt=""
                                                                                            width={100}
                                                                                            className="rounded-circle"
                                                                                        />
                                                                                    </div>
                                                                                    <div>{member.name }</div>
                                                                                    <div className="small text-secondary">
                                                                                        {member.uuid }
                                                                                    </div>
                                                                                    <div>Tele Caller</div>
                                                                                </div>
                                                                            </Paper>
                                                                        </div>
                                                                    ))}
                                                            </div>
                                                            <div className="mt-3">
                                                                <Divider />
                                                            </div>
                                                        </div>


                                                    </div>
                                                </div>
                                            </div>
                                        </Paper>
                                    </AccordionDetails>
                                </Accordion>

                            )
                        })
                    }

                </Box>
            </Box>

            <Modal
                open={open}
                handleClose={() => {
                    setOpen(false);
                }}
                head={action == 'new'?`Add new group template.`: 'Edit group template.'}
                buttons={[
                    {
                        name: "Cancel",
                        onClick: () => {
                            setOpen(false);
                        },
                    },
                    {
                        name: "Create",
                        onClick: () => {
                            if(action == 'new')
                             handleSubmit();
                            else {
                                handleEdit()
                            }

                        },
                    },
                ]}
            >
                {Array.isArray(fields) && (
                    <Box sx={{ mt: 2 }}>
                        <FormA
                            fields={fields}
                            data={{
                                GroupMembers: team.members.filter(e=>!usedMembers[e._id] || formData.members.some(m=>m==e._id))
                            }}
                            onChange={(name, value, multiple) => {
                                formData[name] = value;
                                setFormData({ ...formData });
                            }}
                            state={formData || {}}
                        />
                    </Box>
                )}
            </Modal>

        </>
    )
}